import { DROMO_DATE_FORMAT } from "integrations/dromo/dromoFormats";

export default [
  {
    key: "debtor_external_id",
    label: "Debtor External ID",
    type: "string",
    validators: [{ validate: "require_without_all", fields: ["account_external_id"] }],
    description: "The External ID of the debtor. Provide either this or Account External ID.",
  },
  {
    key: "account_external_id",
    label: "Account External ID",
    type: "string",
    validators: [{ validate: "require_without_all", fields: ["debtor_external_id"] }],
    description: "The External ID of the account. Provide either this or Debtor External ID.",
  },
  {
    key: "notes",
    label: "Communication Notes",
    type: "string",
    validators: [{ validate: "required" }],
    description: "Notes for the communication log entry",
  },
  {
    key: "contact_method",
    label: "Contact Method",
    type: "select",
    validators: [{ validate: "required" }],
    selectOptions: [
      { value: "ai_dialer", label: "AI Phone" },
      { value: "phone", label: "Phone" },
      { value: "text", label: "Text" },
      { value: "email", label: "Email" },
      { value: "mail", label: "Mail" },
      { value: "voicemail", label: "Voicemail" },
      { value: "eoscar", label: "eOscar" },
      { value: "fax", label: "Fax" },
      { value: "in_person", label: "In Person" },
      { value: "other", label: "Other" },
    ],
    description: "The method used to contact the debtor",
  },
  {
    key: "communication_start_time",
    label: "Communication Start Time",
    type: DROMO_DATE_FORMAT,
    description: "The date and time when the communication started (optional)",
  },
  {
    key: "communication_results",
    label: "Communication Result",
    type: "select",
    selectOptions: [
      { value: "", label: "None" },
      { value: "partial_payment", label: "Partial Payment" },
      { value: "full_payment", label: "Full Payment" },
      { value: "promise_to_pay", label: "Promise To Pay" },
      { value: "demanded_payment", label: "Demanded Payment" },
      { value: "disputed_debt", label: "Disputed Debt" },
      { value: "payment_scheduled", label: "Payment Scheduled" },
      { value: "refused_payment", label: "Refused Payment" },
      { value: "got_information", label: "Got Information" },
      { value: "tough_times", label: "Tough Times" },
      { value: "callback_requested", label: "Callback Requested" },
      { value: "information_requested", label: "Information Requested" },
      { value: "spoke_to_third_party", label: "Spoke To Third Party" },
      { value: "complaint", label: "Complaint" },
      { value: "ai_consent_removed", label: "AI Consent Removed" },
      { value: "zortman", label: "Zortman" },
    ],
    description: "The result of the communication (optional)",
  },
  {
    key: "call_results",
    label: "Call Result",
    type: "select",
    selectOptions: [
      { value: "", label: "None" },
      { value: "no_connection", label: "No Connection" },
      { value: "bad_number", label: "Bad Number" },
      { value: "connected", label: "Connected" },
      { value: "line_busy", label: "Line Busy" },
      { value: "voicemail_not_set", label: "Voicemail Not Set" },
      { value: "left_voicemail", label: "Left Voicemail" },
      { value: "voicemail_full", label: "Voicemail Full" },
      { value: "hung_up_in_the_middle", label: "Hung Up In the Middle" },
      { value: "no_answer", label: "No Answer" },
      { value: "dead_air", label: "Dead Air" },
      { value: "disconnected", label: "Disconnected" },
      { value: "phone_not_in_service", label: "Phone Not In Service" },
    ],
    description: "The result of the phone call (optional)",
  },
  {
    key: "text_results",
    label: "Text Result",
    type: "select",
    selectOptions: [
      { value: "", label: "None" },
      { value: "unsuccessful", label: "Unsuccessful" },
      { value: "invalid", label: "Invalid" },
      { value: "debtor_response", label: "Debtor Response" },
      { value: "delivered", label: "Delivered" },
      { value: "opted_in", label: "Opted In" },
      { value: "opted_out", label: "Opted Out" },
    ],
    description: "The result of the text message (optional)",
  },
  {
    key: "email_results",
    label: "Email Result",
    type: "select",
    selectOptions: [
      { value: "", label: "None" },
      { value: "email_unsuccessful", label: "Email Unsuccessful" },
      { value: "email_invalid", label: "Email Invalid" },
      { value: "email_bounced", label: "Email Bounced" },
      { value: "email_delivered", label: "Email Delivered" },
    ],
    description: "The result of the email (optional)",
  },
  {
    key: "voicemail_results",
    label: "Voicemail Result",
    type: "select",
    selectOptions: [
      { value: "", label: "None" },
      { value: "voicemail_unsuccessful", label: "Voicemail Unsuccessful" },
      { value: "voicemail_invalid", label: "Voicemail Invalid" },
      { value: "voicemail_delivered", label: "Voicemail Delivered" },
    ],
    description: "The result of the voicemail (optional)",
  },
  {
    key: "mail_results",
    label: "Mail Result",
    type: "select",
    selectOptions: [
      { value: "", label: "None" },
      { value: "mail_delivered", label: "Mail Delivered" },
      { value: "mail_returned", label: "Mail Returned" },
      { value: "debtor_mail_reply", label: "Debtor Mail Reply" },
    ],
    description: "The result of the mail (optional)",
  },
];
